var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDayToggle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6164_34429)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 33.75C32.0711 33.75 33.75 32.0711 33.75 30C33.75 27.9289 32.0711 26.25 30 26.25C27.9289 26.25 26.25 27.9289 26.25 30C26.25 32.0711 27.9289 33.75 30 33.75ZM30 36C33.3137 36 36 33.3137 36 30C36 26.6863 33.3137 24 30 24C26.6863 24 24 26.6863 24 30C24 33.3137 26.6863 36 30 36Z",
    fill: "#24292E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 18C30.6213 18 31.125 18.5037 31.125 19.125V21.375C31.125 21.9963 30.6213 22.5 30 22.5C29.3787 22.5 28.875 21.9963 28.875 21.375V19.125C28.875 18.5037 29.3787 18 30 18ZM30 37.5C30.6213 37.5 31.125 38.0037 31.125 38.625V40.875C31.125 41.4963 30.6213 42 30 42C29.3787 42 28.875 41.4963 28.875 40.875V38.625C28.875 38.0037 29.3787 37.5 30 37.5Z",
    fill: "#24292E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5149 21.5149C21.9543 21.0756 22.6666 21.0756 23.1059 21.5149L24.6969 23.1059C25.1363 23.5453 25.1363 24.2576 24.6969 24.6969C24.2576 25.1363 23.5453 25.1363 23.1059 24.6969L21.5149 23.1059C21.0756 22.6666 21.0756 21.9543 21.5149 21.5149ZM35.3035 35.3035C35.7429 34.8642 36.4552 34.8642 36.8945 35.3035L38.4855 36.8945C38.9248 37.3338 38.9248 38.0462 38.4855 38.4855C38.0462 38.9248 37.3338 38.9248 36.8945 38.4855L35.3035 36.8945C34.8642 36.4552 34.8642 35.7429 35.3035 35.3035Z",
    fill: "#24292E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 30C42 30.6213 41.4963 31.125 40.875 31.125H38.625C38.0037 31.125 37.5 30.6213 37.5 30C37.5 29.3787 38.0037 28.875 38.625 28.875H40.875C41.4963 28.875 42 29.3787 42 30ZM22.5 30C22.5 30.6213 21.9963 31.125 21.375 31.125H19.125C18.5037 31.125 18 30.6213 18 30C18 29.3787 18.5037 28.875 19.125 28.875H21.375C21.9963 28.875 22.5 29.3787 22.5 30Z",
    fill: "#24292E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4851 21.5149C38.9244 21.9543 38.9244 22.6666 38.4851 23.1059L36.8941 24.6969C36.4547 25.1363 35.7424 25.1363 35.3031 24.6969C34.8637 24.2576 34.8637 23.5453 35.3031 23.1059L36.8941 21.5149C37.3334 21.0756 38.0457 21.0756 38.4851 21.5149ZM24.6965 35.3035C25.1358 35.7429 25.1358 36.4552 24.6965 36.8945L23.1055 38.4855C22.6662 38.9248 21.9538 38.9248 21.5145 38.4855C21.0752 38.0462 21.0752 37.3338 21.5145 36.8945L23.1055 35.3035C23.5448 34.8642 24.2571 34.8642 24.6965 35.3035Z",
    fill: "#24292E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6164_34429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayToggle);
export default __webpack_public_path__ + "static/media/day_toggle.cd16a18b265e6e591f45a30f24d7b822.svg";
export { ForwardRef as ReactComponent };